window.theme = window.theme || {};


/* Toggle Both Drawer Open + Close Functionality */
function getDrawer(id) {
  return document.getElementById(id);
}

let __drawerScrollY = 0; // added line — keeps track of scroll position

function setDrawerOpen(id, open) {
  const drawer = getDrawer(id);
  if (!drawer) return;

  if (open) {
    // lock body scroll and remember position (iOS-safe)
    __drawerScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${__drawerScrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  } else {
    // unlock and restore position
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, __drawerScrollY || 0);
  }

  drawer.classList.toggle('is-open', !!open);
  document.body.classList.toggle('drawer-open', !!open);
}

function toggleDrawer(id) {
  const drawer = getDrawer(id);
  if (!drawer) return;
  const open = !drawer.classList.contains('is-open');
  setDrawerOpen(id, open);
}

/* Drawer APIs */
function toggleCartDrawer() { toggleDrawer('CartDrawer'); }
window.openCartDrawer  = function () { setDrawerOpen('CartDrawer', true); };
window.closeCartDrawer = function () { setDrawerOpen('CartDrawer', false); };

function toggleBurgerDrawer() { toggleDrawer('BurgerDrawer'); }
window.openBurgerDrawer  = function () { setDrawerOpen('BurgerDrawer', true); };
window.closeBurgerDrawer = function () { setDrawerOpen('BurgerDrawer', false); };

document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');

  /* Close button binding for both drawers */
  document.querySelectorAll('.js-drawer-close').forEach(button => {
    button.addEventListener('click', function () {
      const drawer = this.closest('.drawer');
      if (drawer) {
        // 🔧 CHANGED: route through setDrawerOpen to properly unlock body on iOS
        setDrawerOpen(drawer.id, false);
      }
    });
  });

  /* Overlay click closes drawer */
  document.querySelectorAll('.drawer__overlay').forEach(overlay => {
    overlay.addEventListener('click', () => {
      const drawer = overlay.previousElementSibling;
      if (drawer && drawer.classList.contains('drawer')) {
        // 🔧 CHANGED: route through setDrawerOpen to properly unlock body on iOS
        setDrawerOpen(drawer.id, false);
      } else {
        // fallback in case DOM structure changes
        setDrawerOpen('CartDrawer', false);
        setDrawerOpen('BurgerDrawer', false);
      }
    });
  });

  /* Cart drawer Remove-X  */
  if (cartDrawer) {
    cartDrawer.addEventListener('submit', function (event) {
      const form = event.target;
      if (!form.classList.contains('cart-item__remove-form')) return;

      event.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/change.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(response => {
          if (!response.ok) throw new Error('Cart change failed');
          return response.json();
        })
        .then(() => {
          refreshCartDrawer();
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        });
    });
  }


  /* Refresh cart drawer contents */
  window.refreshCartDrawer = function() {
    return fetch('/cart?section_id=drawer-cart')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.getElementById('CartDrawer');
        if (!newDrawer) return;

        cartDrawer.innerHTML = newDrawer.innerHTML;

        // Re-bind close buttons inside refreshed content
        cartDrawer.querySelectorAll('.js-drawer-close').forEach(button => {
          button.addEventListener('click', function () {
            // 🔧 CHANGED: ensure closing uses setDrawerOpen to unlock body
            setDrawerOpen('CartDrawer', false);
          });
        });

        // Re-bind remove forms
        bindRemoveForms();
      });
  }

  function bindRemoveForms() {
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll('.cart-item__remove-form').forEach(form => {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        const formData = new FormData(form);
        fetch('/cart/change.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(response => {
            if (!response.ok) throw new Error('Cart change failed');
            return response.json();
          })
          .then(() => {
            refreshCartDrawer();
          })
          .catch(error => {
            console.error('Error updating cart:', error);
          });
      });
    });
  }


  /* Quantity Selector Logic */

function updateCartQuantity(key, quantity) {
    // 1. Visual Feedback: Change cursor to wait
    document.body.style.cursor = 'wait';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Quantity update failed');
      return response.json();
    })
    .then(() => {
      document.body.style.cursor = 'default';

      // 2. LOGIC: Decide what to refresh
      const isCartPage = document.querySelector('.cartpage');

      if (isCartPage) {
        // Option A: If on the full Cart Page, reload to update totals/layouts accurately
        window.location.reload(); 
      } else {
        // Option B: If in the Drawer, use the smooth refresh function
        if (typeof window.refreshCartDrawer === 'function') {
           window.refreshCartDrawer();
        }
      }
    })
    .catch(error => {
      console.error('Error updating quantity:', error);
      document.body.style.cursor = 'default';
    });
  }

  // 3. Global Event Listener (Delegation)
  // This listens for clicks on ANY quantity button on the whole site
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.quantity-btn');
    if (!btn) return;

    // Find the matching input
    const wrapper = btn.closest('.quantity-selector, .cartpage-quantity-selector');
    const input = wrapper.querySelector('.quantity-input');
    if (!input) return;

    const currentQty = parseInt(input.value);
    
    // Get the ID (support both data-id and data-key)
    const key = btn.dataset.id || input.dataset.key;
    const action = btn.dataset.action;

    let newQty = currentQty;
    if (action === 'increase') {
      newQty += 1;
    } else if (action === 'decrease') {
      newQty = Math.max(0, currentQty - 1);
    }

    // Update the input number visibly immediately
    input.value = newQty;

    // Send the data to Shopify
    updateCartQuantity(key, newQty);
  });

  // 4. Global Listener for Typing in the Input
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('quantity-input')) {
      const key = e.target.dataset.key;
      const newQty = parseInt(e.target.value);
      updateCartQuantity(key, newQty);
    }
  });

  /* Burger toggle */
  const burgerToggle = document.querySelector('.js-burger-toggle');
  if (burgerToggle) {
    burgerToggle.addEventListener('click', toggleBurgerDrawer);
  }

  /* Cart toggle */
  const cartToggle = document.querySelector('.js-cart-toggle');
  if (cartToggle) {
    cartToggle.addEventListener('click', toggleCartDrawer);
  }

  /* Add item to cart */
const productForm = document.querySelector('[data-product-form]');
if (productForm) {
  productForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(productForm);
    formData.set('quantity', '1'); // PDFs: always 1

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        if (typeof refreshCartDrawer === 'function') {
          return refreshCartDrawer().then(() => {
            window.openCartDrawer();
          });
        } else {
          window.openCartDrawer();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
  });
}
});

/* Enforce "single open" for BurgerDrawer parents (all start closed) */
document.addEventListener('change', function (e) {
  if (!e.target.matches('#BurgerDrawer .drawer-acc-toggle')) return;

  if (e.target.checked) {
    const li = e.target.closest('.drawer-nav__parents');
    const list = li && li.parentElement;
    if (!list) return;
    list.querySelectorAll('.drawer-acc-toggle').forEach(t => {
      if (t !== e.target) t.checked = false;
    });
  }
});


/* Spinner button functionality */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.btn-loading-trigger');
  if (!trigger) return;

  const parentSelector = trigger.getAttribute('data-target-parent');
  const targetEl = parentSelector ? trigger.closest(parentSelector) : trigger;

  if (targetEl && !targetEl.classList.contains('btn-loading')) {
    targetEl.classList.add('btn-loading');
    targetEl.setAttribute('aria-busy', 'true');

    const timeoutMs = parseInt(trigger.getAttribute('data-loading-timeout') || '4000', 10);
    setTimeout(() => {
      targetEl.classList.remove('btn-loading');
      targetEl.removeAttribute('aria-busy');
    }, timeoutMs);
  }
});

/* Footer Newsletter — no refresh, spinner, .newsletter-message (hash-safe) */
(function () {
  const FORM_ID = 'FooterNewsletter';

  function showMsg(targetEl, text) {
    if (!targetEl) return;
    let el = targetEl.nextElementSibling;
    if (!el || !el.classList.contains('newsletter-message')) {
      el = document.createElement('div');
      el.className = 'newsletter-message';
      targetEl.insertAdjacentElement('afterend', el);
    }
    el.textContent = text;
    el.style.display = 'block';
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.style.display = 'none'; }, 8000);
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form && form.id === FORM_ID)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const field = form.querySelector('.newsletter-field');
    const input = form.querySelector('input[name="contact[email]"], input[name="customer[email]"]');

    if (field) {
      field.classList.add('btn-loading');
      field.setAttribute('aria-busy', 'true');
    }

    const fd = new FormData(form);
    const raw = form.getAttribute('action') || '/contact';
    const url = raw.split('#')[0] || '/contact';

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.responseType = 'document';

    xhr.onload = function () {
      if (field) {
        field.classList.remove('btn-loading');
        field.removeAttribute('aria-busy');
      }

      console.log('NL status/url:', xhr.status, xhr.responseURL || url);

      if (xhr.responseURL && /\/challenge/.test(xhr.responseURL)) {
        window.location.href = xhr.responseURL;
        return;
      }

      if (xhr.status >= 200 && xhr.status < 300) {
        if (input) input.value = '';
        showMsg(field || form, "You're in! We'll remind you when the shop opens on November 1st");
      } else {
        showMsg(field || form, 'Something went wrong. Please try again.');
        console.error('Newsletter XHR error:', xhr.status, xhr.statusText);
      }
    };

    xhr.onerror = function () {
      if (field) {
        field.classList.remove('btn-loading');
        field.removeAttribute('aria-busy');
      }
      showMsg(field || form, 'Something went wrong. Please try again.');
    };

    xhr.send(fd);
  }, true);
})();


// Product template thumbnail switching + mobile dots
(function () {
  const carousel = document.getElementById('ProductCarousel');
  const slides = carousel ? Array.from(carousel.querySelectorAll('.product-slide')) : [];
  const thumbsWrap = document.querySelector('.product-thumbnails');
  const thumbs = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.product-thumbnail')) : [];
  if (!carousel || !slides.length) return;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  // ----- Build dots (inserted right after the carousel; no HTML edits) -----
  const dotsWrap = document.createElement('div');
  dotsWrap.className = 'product-dots';
  dotsWrap.setAttribute('role', 'tablist');
  dotsWrap.setAttribute('aria-label', 'Image pagination');
  carousel.insertAdjacentElement('afterend', dotsWrap);

  slides.forEach((_, idx) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.dataset.index = String(idx);
    btn.setAttribute('aria-label', `Go to image ${idx + 1}`);
    dotsWrap.appendChild(btn);
  });
  const dots = Array.from(dotsWrap.querySelectorAll('button'));

  // ----- Init (desktop shows first slide as visible) -----
  function init() {
    slides.forEach(s => s.classList.remove('is-active'));
    if (!isMobile()) {
      (slides[0] || {}).classList?.add('is-active');
    }
    setActiveIndicators(0);
  }

  // Update dots + thumbs active state
  function setActiveIndicators(idx) {
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    if (thumbs.length) {
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }
  }

  // Show a specific slide by index
  function showSlide(idx) {
    if (idx < 0 || idx >= slides.length) return;

    if (isMobile()) {
      slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    } else {
      slides.forEach(s => s.classList.remove('is-active'));
      slides[idx].classList.add('is-active');
    }
    currentIndex = idx;
    setActiveIndicators(idx);
  }

  init();
  let currentIndex = 0;

  // Preload/Decode non-first slides on desktop to remove first-hover flash
(function preloadProductSlides() {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;
  if (!canHover || !isDesktop) return;

  // Preload everything except the first (already eager)
  slides.slice(1).forEach(img => {
    if (img.getAttribute('loading') === 'lazy') {
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'low'); // don't compete with LCP
    }
    if (typeof img.decode === 'function') {
      img.decode().catch(() => {});
    }
  });
})();


  // ----- Thumbnail interactions (desktop + keyboard) -----
  if (thumbsWrap) {
    thumbsWrap.addEventListener('click', (e) => {
      const el = e.target.closest('.product-thumbnail');
      if (!el) return;
      const idx = parseInt(el.getAttribute('data-index'), 10) || 0;
      showSlide(idx);
    });
    thumbsWrap.addEventListener('keydown', (e) => {
      const el = e.target.closest('.product-thumbnail');
      if (!el) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const idx = parseInt(el.getAttribute('data-index'), 10) || 0;
        showSlide(idx);
      }
    });

    // ----- Hover-to-swap (desktop only) -----
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      thumbsWrap.addEventListener('mouseover', (e) => {
        if (isMobile()) return; // still keep click/tap on touch
        const el = e.target.closest('.product-thumbnail');
        if (!el) return;
        const idx = parseInt(el.getAttribute('data-index'), 10) || 0;
        if (idx !== currentIndex) showSlide(idx);
      });
    }
  }

  // ----- Dot clicks (mobile indicator + desktop click works too) -----
  dotsWrap.addEventListener('click', (e) => {
    const btn = e.target.closest('button');
    if (!btn) return;
    const idx = parseInt(btn.dataset.index, 10) || 0;
    showSlide(idx);
  });

  // ----- Sync dots while swiping on mobile -----
  let ticking = false;
  carousel.addEventListener('scroll', () => {
    if (!isMobile()) return;
    if (ticking) return;
    window.requestAnimationFrame(() => {
      const idx = Math.round(carousel.scrollLeft / carousel.clientWidth);
      if (idx !== currentIndex) {
        currentIndex = idx;
        setActiveIndicators(idx);
      }
      ticking = false;
    });
    ticking = true;
  }, { passive: true });

  // ----- Normalize after breakpoint change -----
  window.addEventListener('resize', () => {
    if (!isMobile() && !carousel.querySelector('.product-slide.is-active')) {
      (slides[0] || {}).classList?.add('is-active');
      setActiveIndicators(0);
      currentIndex = 0;
    }
  });
})();


// Only one to open at a time within product or faqs accordion
(function () {
  const CONTAINERS = '.product-accordion, .faqs-accordion';

  // Normalize initial state: keep the first open, close the rest
  document.querySelectorAll(CONTAINERS).forEach(container => {
    const openItems = Array.from(container.querySelectorAll('details[open]'));
    openItems.slice(1).forEach(d => (d.open = false));

    // Handle subsequent opens (capture phase to avoid missing the event)
    container.addEventListener(
      'toggle',
      function (e) {
        const details = e.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        if (!details.open) return; // only when one just opened
        // Close all other open details in this container
        container.querySelectorAll('details[open]').forEach(d => {
          if (d !== details) d.open = false;
        });
      },
      true // capture
    );
  });
})();


/* Product Template Carousel Arrow Clicking */
document.addEventListener('DOMContentLoaded', function () {
  var carousel = document.getElementById('ProductCarousel');
  if (!carousel) return;

  var slides = [].slice.call(carousel.querySelectorAll('.product-slide'));
  if (!slides.length) return;

  var prevBtn = carousel.querySelector('.product-nav--prev');
  var nextBtn = carousel.querySelector('.product-nav--next');
  var thumbs  = [].slice.call(document.querySelectorAll('.product-thumbnails .product-thumbnail'));

  var current = Math.max(0, slides.findIndex(function (s){ return s.classList.contains('is-active'); }));

  function show(i){
    if (i < 0 || i >= slides.length) return;
    slides.forEach(function(s, idx){
      s.classList.toggle('is-active', idx === i);
      s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
    });
    thumbs.forEach(function(t, idx){
      t.classList.toggle('is-active', idx === i);
      if (idx === i) t.setAttribute('aria-current','true'); else t.removeAttribute('aria-current');
    });
    current = i;
  }

  function next(){ show((current + 1) % slides.length); }
  function prev(){ show((current - 1 + slides.length) % slides.length); }

  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  thumbs.forEach(function(t, i){
    var idx = parseInt(t.getAttribute('data-index'), 10);
    t.addEventListener('click', function(){ show(isNaN(idx) ? i : idx); });
    t.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(isNaN(idx) ? i : idx); }
    });
  });

  carousel.setAttribute('tabindex', '0');
  carousel.addEventListener('keydown', function(e){
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft')  prev();
  });

  show(current);
});

document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('.carousel');
  if (!carousel) return;

  const prev = document.querySelector('.prev');
  const next = document.querySelector('.next');

  const step = () => carousel.children[0].offsetWidth + 16;

  next?.addEventListener('click', () => {
    const max = carousel.scrollWidth - carousel.clientWidth;

    if (carousel.scrollLeft >= max - 5) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: step(), behavior: 'smooth' });
    }
  });

  prev?.addEventListener('click', () => {
    if (carousel.scrollLeft <= 5) {
      carousel.scrollTo({ left: carousel.scrollWidth, behavior: 'smooth' });
    } else {
      carousel.scrollBy({ left: -step(), behavior: 'smooth' });
    }
  });
});
